// LSW logo: brand mark (CMYK painted heart) + wordmark
const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_lsw-journey/artifacts/9aaegveq_solo%20cuore%20cmyk%20%283%29.png";

export default function LSWLogo({
  size = 70,
  withWordmark = true,
  layout = "horizontal",
  className = "",
}) {
  const isVertical = layout === "vertical";

  return (
    <div
      className={`flex ${
        isVertical ? "flex-col items-center gap-3" : "flex-row items-center gap-4"
      } ${className}`}
      data-testid="lsw-logo"
    >
      <img
        src={LOGO_URL}
        alt="Love Shaman Way"
        style={{
          height: size,
          width: "auto",
          background: "transparent",
          objectFit: "contain",
        }}
        draggable={false}
      />
      {withWordmark && (
        <div
          className={`flex flex-col ${
            isVertical ? "items-center" : "items-start"
          } leading-none`}
        >
          <span
            className="font-serif-display font-medium tracking-[0.18em] text-[#2e2820]"
            style={{ fontSize: isVertical ? 22 : 20 }}
          >
            LOVE SHAMAN WAY
          </span>
          <span className="font-body text-[10px] font-light tracking-[0.4em] text-[#7a6f65] mt-1.5">
            · L S W ·
          </span>
        </div>
      )}
    </div>
  );
}
